import { Injectable } from "@angular/core";
import { ICountry } from "./ICountry";

@Injectable({
    providedIn: 'root'
})
export class SmsInputService {
    constructor() { }

    getCountries(): ICountry[] {
        return [{
            name: "Australia/Cocos/Christmas Island",
            dialCode: 61,
            countryCode: "au",
            isoCode: "036",
            replaceablePrefix: 0,
            exampleMobileNumber: `+61723456789`
        },
        {
            name: "Austria",
            dialCode: 43,
            countryCode: "at",
            isoCode: "040",
            replaceablePrefix: 0,
            exampleMobileNumber: `+431234567890`
        },
        {
            name: "Belgium",
            dialCode: 32,
            countryCode: "be",
            isoCode: "056",
            replaceablePrefix: 0,
            exampleMobileNumber: `+3212345678`
        },
        {
            name: "Brazil (Brasil)",
            dialCode: 55,
            countryCode: "br",
            isoCode: "076",
            replaceablePrefix: 0,
            exampleMobileNumber: `+5501234567890`
        },
        {
            name: "Canada",
            dialCode: 1,
            countryCode: "ca",
            isoCode: "124",
            replaceablePrefix: 0,
            exampleMobileNumber: `+12345678999`
        },
        {
            name: "Denmark (Danmark)",
            dialCode: 45,
            countryCode: "dk",
            isoCode: "208",
            replaceablePrefix: 0,
            exampleMobileNumber: `+4523456789`
        },
        {
            name: "France",
            dialCode: 33,
            countryCode: "fr",
            isoCode: "250",
            replaceablePrefix: 0,
            exampleMobileNumber: `+33123456789`
        },
        {
            name: "Finland (Suomi)",
            dialCode: 358,
            countryCode: "fi",
            isoCode: "246",
            replaceablePrefix: 0,
            exampleMobileNumber: `+358023456789`
        },
        {
            name: "Germany (Deutschland)",
            dialCode: 49,
            countryCode: "de",
            isoCode: "276",
            replaceablePrefix: 0,
            exampleMobileNumber: `+49123456789`
        },
        {
            name: "Hungary (Magyarország)",
            dialCode: 36,
            countryCode: "hu",
            isoCode: "348",
            replaceablePrefix: 0,
            exampleMobileNumber: `+3612345678`
        },
        {
            name: "Ireland",
            dialCode: 353,
            countryCode: "ie",
            isoCode: "372",
            replaceablePrefix: 0,
            exampleMobileNumber: `+35312345678`
        },
        {
            name: "Netherlands (Nederland)",
            dialCode: 31,
            countryCode: "nl",
            isoCode: "528",
            replaceablePrefix: 0,
            exampleMobileNumber: `+31123456789`
        },
        {
            name: "Norway (Norge)",
            dialCode: 47,
            countryCode: "no",
            isoCode: "578",
            replaceablePrefix: 0,
            exampleMobileNumber: `+4723456789`
        },
        {
            name: "Poland (Polska)",
            dialCode: 48,
            countryCode: "pl",
            isoCode: "616",
            replaceablePrefix: 0,
            exampleMobileNumber: `+481234567`
        },
        {
            name: "Qatar (‫قطر‬‎)",
            dialCode: 974,
            countryCode: "qa",
            isoCode: "634",
            replaceablePrefix: 0,
            exampleMobileNumber: `+97434567890`
        },
        {
            name: "Spain (España)",
            dialCode: 34,
            countryCode: "es",
            isoCode: "724",
            replaceablePrefix: 0,
            exampleMobileNumber: `+34555555555`
        },
        {
            name: "Sweden (Sverige)",
            dialCode: 46,
            countryCode: "se",
            isoCode: "752",
            replaceablePrefix: 0,
            exampleMobileNumber: `+46555555555`
        },
        {
            name: "Switzerland",
            dialCode: 41,
            countryCode: "ch",
            isoCode: "756",
            replaceablePrefix: 0,
            exampleMobileNumber: `+41345678900`
        },
        {
            name: "United Kingdom",
            dialCode: 44,
            countryCode: "gb",
            isoCode: "826",
            replaceablePrefix: 0,
            exampleMobileNumber: `+441234567890`
        },
        {
            name: "United States",
            dialCode: 1,
            countryCode: "us",
            isoCode: "840",
            replaceablePrefix: 0,
            exampleMobileNumber: `+112345678901`
        }];
    }
}
